"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualList = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactVirtual = require("react-virtual");

var _nicbaseIcons = require("nicbase-icons");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var VirtualList = function VirtualList(_ref) {
  var width = _ref.width,
      height = _ref.height,
      role = _ref.role,
      maxHeight = _ref.maxHeight,
      overscan = _ref.overscan,
      options = _ref.options,
      optionRenderer = _ref.optionRenderer,
      isFetchingMore = _ref.isFetchingMore,
      fetchMore = _ref.fetchMore,
      canFetchMore = _ref.canFetchMore;
  var parentRef = (0, _react.useRef)();
  var rowVirtualizer = (0, _reactVirtual.useVirtual)({
    size: canFetchMore ? options.length + 1 : options.length,
    // add "loader" row
    parentRef: parentRef,
    overscan: overscan
  });
  (0, _react.useEffect)(function () {
    var _reverse = _toConsumableArray(rowVirtualizer.virtualItems).reverse(),
        _reverse2 = _slicedToArray(_reverse, 1),
        lastItem = _reverse2[0];

    if (!lastItem) {
      return;
    }

    if (lastItem.index >= options.length - 1 && canFetchMore && !isFetchingMore) {
      fetchMore();
    }
  }, [canFetchMore, fetchMore, isFetchingMore, options.length, rowVirtualizer.virtualItems]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: parentRef,
    role: role,
    style: {
      width: width,
      height: height,
      maxHeight: maxHeight
    },
    className: "overflow-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: "".concat(rowVirtualizer.totalSize, "px"),
      width: '100%',
      position: 'relative'
    }
  }, rowVirtualizer.virtualItems.map(function (virtualRow) {
    return virtualRow.index < options.length ? optionRenderer({
      key: String(virtualRow.index),
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        transform: "translateY(".concat(virtualRow.start, "px)")
      },
      option: options[virtualRow.index],
      options: options,
      optionIndex: virtualRow.index,
      measureRef: virtualRow.measureRef
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      ref: function ref(element) {
        return virtualRow.measureRef(element);
      },
      key: String(virtualRow.index),
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        transform: "translateY(".concat(virtualRow.start, "px)")
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, {
      className: "h-10 p-1 flex justify-center"
    }));
  })));
};

exports.VirtualList = VirtualList;
VirtualList.defaultProps = {
  role: 'listbox',
  overscan: 10,
  isFetchingMore: false,
  fetchMore: null,
  canFetchMore: false
};